import React from "react";
import { motion } from "framer-motion";

export default function Info({ backgroundColor = "#f5fdfd" }) {
  const agendaDays = [
    {
      title: "DAY ONE | APRIL 15, 2026",
      delay: 0.1,
      sessions: [
        {
          time: "9:00 AM",
          location: "Hotel Lobby & Hilltop Dining Room",
          title: "Arrivals & Executive Networking",
        },
        {
          time: "2:00 PM",
          location: "Napa Hall",
          title: "Opening Remarks",
          details: "Ian Siegel, CEO",
        },
        {
          time: "2:30 PM",
          location: "Napa Hall",
          title: "Introductions & AI in Action Breakout: What to Start, Stop, and Scale",
          details: "David Travers, President & CFO",
        },
        {
          time: "3:30 PM",
          title: "Open Time",
        },
        {
          time: "5:00 PM",
          location: "Hilltop Dining Room & Patio",
          title: "Welcome Toast & Networking Reception",
        },
        {
          time: "6:00 PM",
          location: "Hilltop Dining Room",
          title: "Dinner",
        },
        {
          time: "8:00 PM",
          location: "Hilltop Living Room & Courtyard",
          title: "Evening Experience",
        },
      ],
    },
    {
      title: "DAY TWO | APRIL 16, 2026",
      delay: 0.2,
      sessions: [
        {
          time: "8:00 AM",
          location: "Carneros Courtyard",
          title: "Breakfast",
        },
        {
          time: "9:00 AM",
          location: "Napa Hall",
          title: "Economic Outlook: Navigating the Future of Work",
          details:
            "David Travers, President & CFO, and Bharat Chandar, Stanford Economist",
        },
        {
          time: "9:45 AM",
          location: "Napa Hall",
          title: "Emerging Innovations in Product & Technology",
          details:
            "Megan Allen, CPO & Paris Marron, VP, Product",
        },
        {
          time: "10:30 AM",
          title: "Break",
        },
        {
          time: "10:45 AM",
          location: "Napa Hall",
          title: "Executive Panel: Scaling Authenticity in the Digital Hiring Experience",
          details:
            "Hosted by Michael Nasif, SVP Enterprise, featuring leaders from Visa, La-Z-Boy, EchoStar, and First Student",
        },
        {
          time: "11:45 AM",
          location: "Napa Hall",
          title: "Talent Strategy Masterclass: Attracting and Engaging Top Talent",
          details: "Sam DeMase, Career Expert",
        },
        {
          time: "12:30 PM",
          location: "Carneros Courtyard",
          title: "Lunch",
        },
        {
          time: "1:30 PM",
          title: "Open Time for Networking & Reflection",
        },
        {
          time: "4:00 PM",
          title: "Departure to Sleeping Giant Winery",
        },
        {
          time: "4:30 PM",
          location: "Sleeping Giant Winery, Tasting Room",
          title: "Curated Winery Experience: Tour & Tasting",
        },
        {
          time: "6:30 PM",
          location: "Sleeping Giant Winery, Barrel Room",
          title: "Dinner Onsite at Sleeping Giant Winery",
        },
        {
          time: "8:30 PM",
          location: "Hotel Bar",
          title: "Return to Carneros Resort",
          details: "Informal Networking",
        },
      ],
    },
    {
      title: "DAY THREE | APRIL 17, 2026",
      delay: 0.3,
      sessions: [
        {
          time: "8:00 AM",
          location: "Carneros Courtyard",
          title: "Breakfast",
        },
        {
          time: "9:00 AM",
          location: "Napa Hall",
          title: "Breakroom: Building a Differentiated Employer Brand at Scale",
          details: "Christian Malpeli, VP, Corporate Development",
        },
        {
          time: "9:30 AM",
          location: "Napa Hall",
          title: "The Human Edge in an AI World",
          details: "Scott Hartley, Everywhere Ventures",
        },
        {
          time: "10:00 AM",
          location: "Napa Hall",
          title: "Fireside Chat: Insights on Market Trends & Talent Strategy",
          details: "Ryan Armer, Sr. Director, Enterprise & Nicole Bachaud, Labor Economist",
        },
        {
          time: "10:45 AM",
          location: "Napa Hall",
          title: "Key Takeaways & Strategic Action Planning",
          details: "David Travers, President & CFO, & Michael Nasif, SVP Enterprise",
        },
        {
          time: "11:30 AM",
          location: "Carneros Courtyard",
          title: "Farewell Lunch Reception",
          details: "Dine in or take away as you depart",
        },
      ],
    },
  ];

  return (
    <section className="info" style={{ backgroundColor }}>
      <div className="auto__container">
        <div className="info__inner agenda-info">
          <motion.div
            animate={{
              x: [50, 0],
              opacity: [0, 1],
            }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
          >
            <div className="info__inner-title">
              <h2>AGENDA</h2>
              <p>
                A curated experience designed to inspire connection, insight, and
                leadership. Additional details to follow.
              </p>
            </div>
          </motion.div>

          <div className="info__inner-main">
            {agendaDays.map((day, dayIndex) => (
              <div className="infoContent" key={day.title}>
                <motion.div
                  animate={{
                    x: [50, 0],
                    opacity: [0, 1],
                  }}
                  transition={{ duration: 0.8, ease: "easeOut", delay: day.delay }}
                >
                  <h4>{day.title}</h4>
                  <ul>
                    {day.sessions.map((session, sessionIndex) => (
                      <li key={`${dayIndex}-${sessionIndex}-${session.time}`}>
                        <div className="time">{session.time}</div>
                        <div className="info-container">
                          <p>{session.title}</p>
                          {session.details && <p className="sm">{session.details}</p>}
                          {session.location && (
                            <div className="location-container">
                              <div className="pin-container">
                                <img
                                  src={process.env.PUBLIC_URL + "/images/pin-2.svg"}
                                  alt="Location pin"
                                  className="location-pin img-fluid"
                                />
                              </div>
                              <div className="location-text">{session.location}</div>
                            </div>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bottom-button-container info">
        <a
          href="https://cvent.me/k8rkmN"
          target="_blank"
          rel="noreferrer"
          className="button primary"
        >
          REGISTER NOW
        </a>
      </div>
    </section>
  );
}
